<template>
  <div class="content">
    <form>
      <refund-form :datas="dataall"></refund-form>
      <kontragent :datas="dataall"></kontragent>
      <firma></firma>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
    </form>
  </div>
</template>
<script>
import { RefundForm, Kontragent, Firma, Sklad, Paytype } from "@/pages";
export default {
  components: {
    RefundForm,
    Kontragent,
    Firma,
    Sklad,
    Paytype
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   if (this.$store.state.saved < 2) {
  //     this.$store.state.saved = null;
  //     next();
  //   } else {
  //     this.$bvModal.show("modal-close");

  //   }
  // },
  methods:{
  }, 
  created: function() {
    let self=this;
    axios
        .get("api/v1/refund/last-number")
        .then(function(response) {
            self.dataall.number=response.data.number;
            self.$store.state.saved=null;
        });
        axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            self.dataall.dollar_rate=response.data.rate;
            self.$store.state.saved=null;
        });
  },
  data() {
    return {
      dataall: {
        created_at: new Date().valueOf().toString().slice(0, 10),
        updated_at: new Date().valueOf().toString().slice(0, 10),
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        skidka_summa:0,
        kontragent_id: 0,
        user_id: parseInt(localStorage.getItem("user_id")),
        pay_type_id: 1,
        price_type: "chakana",
        summa: 0,
        cash_summa: 0,
        plastic_summa: 0,
        count_all: 0,
        comment: "",
        dollar_rate:0,
        dollar_summa:0,
        refund_table: [
          {
            product_id: 0,
            count: 0,
            price: 0,
            summa: 0,
            shtrix_kod: null,
            current_balance: 0
          }
        ]
      }
    };
  }
};
</script>
